import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

class CartCountLoadComponent extends BridgeComponent {
    static component = "cartload";

    connect() {
        super.connect();
    }

    cartLoad() {
        var cartCount = localStorage.getItem("cartCount") || 0;
        // This method can be used to trigger cart-related actions
        this.send("cartupdate", { cart: cartCount }, (response) => {
            console.log("📨 Cart action response:", response);
        });
    }
}
export default CartCountLoadComponent;
